var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import errorCoverImage from "././assets/error-icon.svg";
var MASONRY_WIDGET_ASSETS_MAP = {
  ERROR_STATE_COVER: errorCoverImage
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(MASONRY_WIDGET_ASSETS_MAP);
};

// src/hooks/use-get-traits-for-media.hook.ts
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";
var useGetTraitsForMedia = (traits) => {
  const isMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));
  const isTablet = useMediaQuery(
    queryHelpers.between(["mobileLandscape", "laptop"])
  );
  const isLaptop = useMediaQuery(queryHelpers.only("laptop"));
  const isDesktop = useMediaQuery(queryHelpers.up("desktop"));
  if (isMobile)
    return traits == null ? void 0 : traits.mobile;
  if (isTablet)
    return traits == null ? void 0 : traits.tablet;
  if (isLaptop)
    return traits == null ? void 0 : traits.laptop;
  if (isDesktop)
    return traits == null ? void 0 : traits.desktop;
  return {};
};

// src/hooks/use-orientation-from-media-query.hook.ts
import { queryHelpers as queryHelpers2, useMediaQuery as useMediaQuery2 } from "@leagueplatform/genesis-core";
import { SupportedMedia as SupportedMedia2 } from "@leagueplatform/masonry-api";

// src/utils/default-orientation-map.ts
import {
  WidgetType,
  Orientation,
  SupportedMedia
} from "@leagueplatform/masonry-api";
var DefaultOrientationMap = {
  Default: Orientation.VERTICAL,
  [WidgetType.STACK]: {
    [SupportedMedia.MOBILE]: Orientation.VERTICAL,
    [SupportedMedia.TABLET]: Orientation.VERTICAL,
    [SupportedMedia.LAPTOP]: Orientation.HORIZONTAL,
    [SupportedMedia.DESKTOP]: Orientation.HORIZONTAL
  }
};

// src/hooks/use-orientation-from-media-query.hook.ts
var useOrientationFromMediaQuery = ({
  defaultOrientation,
  traits
}) => {
  var _a, _b, _c, _d;
  const isMobile = useMediaQuery2(queryHelpers2.down("mobileLandscape"));
  const isTablet = useMediaQuery2(queryHelpers2.only("tablet"));
  const isLaptop = useMediaQuery2(queryHelpers2.only("laptop"));
  const isDesktop = useMediaQuery2(queryHelpers2.up("desktop"));
  if (isMobile)
    return ((_a = traits == null ? void 0 : traits.mobile) == null ? void 0 : _a.orientation) || defaultOrientation[SupportedMedia2.MOBILE];
  if (isTablet)
    return ((_b = traits == null ? void 0 : traits.tablet) == null ? void 0 : _b.orientation) || defaultOrientation[SupportedMedia2.TABLET];
  if (isLaptop)
    return ((_c = traits == null ? void 0 : traits.laptop) == null ? void 0 : _c.orientation) || defaultOrientation[SupportedMedia2.LAPTOP];
  if (isDesktop)
    return ((_d = traits == null ? void 0 : traits.desktop) == null ? void 0 : _d.orientation) || defaultOrientation[SupportedMedia2.DESKTOP];
  return DefaultOrientationMap.Default;
};

// src/components/large-visual-card-widget/large-visual-card-widget.component.tsx
import React7, { useRef } from "react";

// src/components/common/large-image-card/large-image-card.component.tsx
import React3 from "react";
import { queryHelpers as queryHelpers3, useMediaQuery as useMediaQuery3 } from "@leagueplatform/genesis-core";

// src/components/common/vertical-large-image-card/vertical-large-image-card.component.tsx
import React from "react";
import { StackLayout } from "@leagueplatform/genesis-core";

// src/components/common/common.tsx
import { css, genesisStyled, Image } from "@leagueplatform/genesis-commons";
var StyledImg = genesisStyled(Image)(
  css({
    objectFit: "cover"
  })
);

// src/components/common/vertical-large-image-card/vertical-large-image-card.component.tsx
var VerticalLargeImageCard = ({
  image,
  imageAltText,
  children
}) => /* @__PURE__ */ React.createElement(
  StackLayout,
  {
    orientation: "vertical",
    verticalAlignment: "spaceBetween",
    horizontalAlignment: "stretch",
    spacing: "$none"
  },
  /* @__PURE__ */ React.createElement(
    StyledImg,
    {
      borderStartEndRadius: "medium",
      borderStartStartRadius: "medium",
      borderStyle: "solid",
      src: image,
      width: "100%",
      height: "176px",
      alt: imageAltText
    }
  ),
  children
);

// src/components/common/horizontal-large-image-card/horizontal-large-image-card.component.tsx
import React2 from "react";
import { StackLayout as StackLayout2 } from "@leagueplatform/genesis-core";
var HorizontalLargeImageCard = ({
  image,
  imageAltText,
  children,
  imageAlign = "left"
}) => {
  const isImageAlignLeading = imageAlign === "left" || imageAlign === "leading";
  return /* @__PURE__ */ React2.createElement(
    StackLayout2,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      spacing: "$oneAndHalf",
      verticalAlignment: "center",
      css: { flexFlow: isImageAlignLeading ? "row-reverse" : "row" }
    },
    children,
    /* @__PURE__ */ React2.createElement(
      StyledImg,
      {
        borderStartStartRadius: isImageAlignLeading && "medium",
        borderEndStartRadius: isImageAlignLeading && "medium",
        borderStartEndRadius: !isImageAlignLeading && "medium",
        borderEndEndRadius: !isImageAlignLeading && "medium",
        borderStyle: "solid",
        src: image,
        width: "350px",
        minHeight: "176px",
        height: "100%",
        alt: imageAltText
      }
    )
  );
};

// src/components/common/large-image-card/large-image-card.component.tsx
var LargeImageCard = ({
  image,
  imageAltText = "",
  isChildItem = false,
  imageAlign,
  children
}) => {
  const isMobile = useMediaQuery3(queryHelpers3.down("mobileLandscape"));
  const CardComponent = isMobile || isChildItem ? VerticalLargeImageCard : HorizontalLargeImageCard;
  return /* @__PURE__ */ React3.createElement(
    CardComponent,
    {
      image,
      imageAltText,
      imageAlign
    },
    children
  );
};

// src/components/large-visual-card-widget/large-visual-card-widget.component.tsx
import { ConditionalLinkCard } from "@leagueplatform/web-common-components";

// src/components/large-visual-card-widget/large-visual-card-content.component.tsx
import React6 from "react";
import {
  Box,
  HeadingThree,
  Overline,
  SubtitleOne,
  Text
} from "@leagueplatform/genesis-commons";

// src/common/badge-list/badge-list.component.tsx
import * as React5 from "react";
import { UtilityText, StackLayout as StackLayout4, Icon } from "@leagueplatform/genesis-core";
import { uniqueId } from "lodash";

// src/common/badge-pill/badge-pill.component.tsx
import React4 from "react";
import { StackLayout as StackLayout3 } from "@leagueplatform/genesis-core";
var BadgePill = ({
  children,
  backgroundColor = "$decorativeBrandSecondaryBright"
}) => /* @__PURE__ */ React4.createElement(
  StackLayout3,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    spacing: "$quarter",
    css: {
      flex: "0 0 auto",
      borderStyle: "$solid",
      borderRadius: "$pill",
      paddingInline: "$half",
      paddingBlock: "$quarter",
      width: "fit-content",
      backgroundColor
    }
  },
  children
);

// src/common/badge-list/badge-list.component.tsx
var BadgeList = ({ badges, backgroundColor }) => /* @__PURE__ */ React5.createElement(
  StackLayout4,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    spacing: "$threeQuarters",
    css: {
      flexWrap: "wrap"
    }
  },
  badges == null ? void 0 : badges.map(({ image, imageAltText, body }) => /* @__PURE__ */ React5.createElement(BadgePill, { key: uniqueId(), backgroundColor }, image && /* @__PURE__ */ React5.createElement(Icon, { icon: image, label: imageAltText, size: "$threeQuarters" }), body && /* @__PURE__ */ React5.createElement(
    UtilityText,
    {
      emphasis: "emphasized",
      size: "sm",
      css: {
        color: "$onSurfaceTextPrimary",
        textAlign: "center"
      }
    },
    body
  )))
);

// src/components/large-visual-card-widget/large-visual-card-content.component.tsx
import { ConditionalLink } from "@leagueplatform/web-common-components";
import { ParagraphText, StackLayout as StackLayout5 } from "@leagueplatform/genesis-core";

// src/utils/body-text-html-tag-options.ts
import { TextAction } from "@leagueplatform/genesis-core";
import { InternalOrExternalLinkButton } from "@leagueplatform/web-common-components";
var BodyTextHtmlTagOptions = {
  a: {
    component: InternalOrExternalLinkButton,
    props: {
      baseComponent: TextAction,
      // Stop event propagation to prevent triggering on card click event on click of link inside paragraph text
      onClick: (e) => e.stopPropagation()
    }
  }
};

// src/components/large-visual-card-widget/large-visual-card-content.component.tsx
var LargeVisualCardContent = ({
  overline,
  linkRefState,
  linkUrl,
  title,
  description,
  badges,
  traits,
  onCardClick
}) => {
  const overlineId = `lvc-${title.replace(/\s+/g, "-")}`;
  const traitItems = useGetTraitsForMedia(traits);
  return /* @__PURE__ */ React6.createElement(
    StackLayout5,
    {
      spacing: "$half",
      orientation: "vertical",
      css: {
        padding: "$oneAndHalf"
      }
    },
    overline && /* @__PURE__ */ React6.createElement(Overline, { as: Text, id: overlineId, color: "onSurface.text.subdued" }, overline),
    /* @__PURE__ */ React6.createElement(StackLayout5, { spacing: "$quarter", orientation: "vertical" }, /* @__PURE__ */ React6.createElement(
      SubtitleOne,
      {
        as: HeadingThree,
        "aria-describedby": overlineId,
        fontWeight: "bold"
      },
      /* @__PURE__ */ React6.createElement(
        ConditionalLink,
        {
          ref: linkRefState,
          url: linkUrl,
          onClick: onCardClick
        },
        title
      )
    ), /* @__PURE__ */ React6.createElement(ParagraphText, { htmlStringOptions: BodyTextHtmlTagOptions }, description)),
    badges && /* @__PURE__ */ React6.createElement(Box, { marginTop: "threeQuarters" }, /* @__PURE__ */ React6.createElement(
      BadgeList,
      {
        badges,
        backgroundColor: traitItems == null ? void 0 : traitItems.badgeBackgroundColor
      }
    ))
  );
};

// src/components/large-visual-card-widget/large-visual-card-widget.component.tsx
var LargeVisualCardWidget = (_a) => {
  var _b = _a, {
    image,
    imageAltText,
    isChildItem,
    linkUrl,
    traits
  } = _b, props = __objRest(_b, [
    "image",
    "imageAltText",
    "isChildItem",
    "linkUrl",
    "traits"
  ]);
  const linkRefState = useRef(null);
  const traitItems = useGetTraitsForMedia(traits);
  const iconAlign = (traitItems == null ? void 0 : traitItems.iconAlignment) || "right";
  return /* @__PURE__ */ React7.createElement(
    ConditionalLinkCard,
    {
      linkRef: linkRefState,
      hasLink: Boolean(linkUrl),
      cardStyle: { backgroundColor: "surface.card.secondary" }
    },
    /* @__PURE__ */ React7.createElement(
      LargeImageCard,
      {
        image,
        imageAlign: iconAlign,
        imageAltText,
        isChildItem: isChildItem || (traitItems == null ? void 0 : traitItems.isChildItem)
      },
      /* @__PURE__ */ React7.createElement(
        LargeVisualCardContent,
        __spreadValues({
          linkUrl,
          linkRefState,
          traits
        }, props)
      )
    )
  );
};

// src/components/text-cta-card-widget/text-cta-card-widget.component.tsx
import React9 from "react";
import { PrimaryButton, genesisStyled as genesisStyled2 } from "@leagueplatform/genesis-commons";
import {
  HeadingText,
  UtilityText as UtilityText2,
  ParagraphText as ParagraphText2,
  queryHelpers as queryHelpers4,
  StackLayout as StackLayout6,
  useMediaQuery as useMediaQuery4,
  ButtonIndicator,
  Box as Box3
} from "@leagueplatform/genesis-core";
import { isAbsoluteUrl } from "@leagueplatform/web-common";
import {
  ConditionalLinkCard as ConditionalLinkCard2,
  InternalOrExternalLinkButton as InternalOrExternalLinkButton2
} from "@leagueplatform/web-common-components";

// src/common/square-image-container/square-image-container.component.tsx
import * as React8 from "react";
import { Box as Box2, styled } from "@leagueplatform/genesis-core";
var StyledImgContainer = styled(Box2, {
  borderRadius: "medium",
  maxHeight: "$$maxImageWidth",
  maxWidth: "$$maxImageWidth",
  aspectRatio: "1 / 1",
  flex: 1,
  overflow: "hidden",
  "@tablet": {
    maxHeight: "$$maxWidthDesktop",
    maxWidth: "$$maxWidthDesktop"
  }
});
var StyledImg2 = styled("img", {
  width: "100%",
  height: "100%",
  objectFit: "cover"
});
var SquareImageContainer = ({
  src,
  maxWidth,
  maxWidthDesktop,
  alt
}) => /* @__PURE__ */ React8.createElement(
  StyledImgContainer,
  {
    css: { $$maxImageWidth: maxWidth, $$maxWidthDesktop: maxWidthDesktop }
  },
  /* @__PURE__ */ React8.createElement(StyledImg2, { src, alt })
);

// src/utils/button-icon-mapping.ts
var IconTokenByString = {
  NEW_TAB_INTERNAL: "newTabInternal",
  NEW_WINDOW_INTERNAL: "newWindowInternal",
  EXTERNAL_LINK: "externalLink"
};
var getIconToken = (indicatorString) => IconTokenByString[indicatorString];

// src/components/text-cta-card-widget/text-cta-card-widget.component.tsx
var StyledButton = genesisStyled2(PrimaryButton)`
  text-decoration: none !important;
  text-align: center;
`;
var TextAndCTACardWidget = ({
  buttonIndicator,
  buttonText,
  description,
  eyebrow,
  image,
  imageAltText = "",
  isChildItem = false,
  isThinWidth = false,
  linkUrl = "",
  onCardClick = () => {
  },
  title,
  traits
}) => {
  const isExternalUrl = isAbsoluteUrl(linkUrl);
  const isMobile = useMediaQuery4(queryHelpers4.only("mobile"));
  const showSmallerCard = isMobile || isChildItem || isThinWidth;
  const traitItems = useGetTraitsForMedia(traits);
  return /* @__PURE__ */ React9.createElement(
    ConditionalLinkCard2,
    {
      cardStyle: {
        padding: "oneAndHalf",
        flexDirection: "column",
        backgroundColor: (traitItems == null ? void 0 : traitItems.backgroundColor) || "surface.background.tertiary"
      }
    },
    /* @__PURE__ */ React9.createElement(
      StackLayout6,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: {
          "@mobile": "$threeQuarters",
          "@initial": showSmallerCard ? "$threeQuarters" : "$oneAndHalf"
        }
      },
      /* @__PURE__ */ React9.createElement(StackLayout6, { orientation: "vertical", spacing: "$quarter" }, eyebrow && /* @__PURE__ */ React9.createElement(UtilityText2, { size: "eyebrow" }, eyebrow), /* @__PURE__ */ React9.createElement(HeadingText, { level: "3", size: "sm" }, title), /* @__PURE__ */ React9.createElement(ParagraphText2, { htmlStringOptions: BodyTextHtmlTagOptions }, description), !showSmallerCard && /* @__PURE__ */ React9.createElement(
        StyledButton,
        {
          paddingY: "half",
          as: InternalOrExternalLinkButton2,
          isExternalUrl,
          href: linkUrl,
          marginTop: "one",
          onClick: onCardClick
        },
        /* @__PURE__ */ React9.createElement(Box3, { as: "span", css: { display: "inline-flex" } }, buttonText, buttonIndicator && /* @__PURE__ */ React9.createElement(
          ButtonIndicator,
          {
            wrapperSpacing: "large",
            indicator: getIconToken(buttonIndicator),
            responsiveSize: "large"
          }
        ))
      )),
      image && /* @__PURE__ */ React9.createElement(
        SquareImageContainer,
        {
          src: image,
          alt: imageAltText,
          maxWidth: "8rem",
          maxWidthDesktop: isChildItem ? "8rem" : "11.2rem"
        }
      )
    ),
    showSmallerCard && /* @__PURE__ */ React9.createElement(
      StyledButton,
      {
        width: "100%",
        paddingY: "half",
        as: InternalOrExternalLinkButton2,
        isExternalUrl,
        href: linkUrl,
        marginTop: "one",
        onClick: onCardClick
      },
      /* @__PURE__ */ React9.createElement(Box3, { as: "span", css: { display: "inline-flex" } }, buttonText, buttonIndicator && /* @__PURE__ */ React9.createElement(
        ButtonIndicator,
        {
          wrapperSpacing: "large",
          indicator: getIconToken(buttonIndicator),
          responsiveSize: "large"
        }
      ))
    )
  );
};

// src/components/xsvisual-card-widget/xsvisual-card-widget.component.tsx
import React10, { useRef as useRef2 } from "react";
import {
  css as css2,
  Flex,
  genesisStyled as genesisStyled3,
  SubtitleOne as SubtitleOne2,
  Image as Image2,
  HeadingThree as HeadingThree2
} from "@leagueplatform/genesis-commons";
import {
  StackLayout as StackLayout7,
  ConditionalLinkCard as ConditionalLinkCard3,
  ConditionalLink as ConditionalLink2
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText3 } from "@leagueplatform/genesis-core";
var StyledImage = genesisStyled3(Image2)(
  css2({
    contentFit: "cover",
    contentPosition: "center",
    height: "42px",
    width: "42px"
  })
);
var XSVisualCardWidget = ({
  actionLink,
  body,
  heading,
  image,
  imageAltText,
  onCardClick = () => {
  },
  traits
}) => {
  const linkRef = useRef2(null);
  const traitItems = useGetTraitsForMedia(traits);
  return /* @__PURE__ */ React10.createElement(
    ConditionalLinkCard3,
    {
      linkRef,
      hasLink: Boolean(actionLink),
      cardStyle: {
        padding: "oneAndHalf",
        alignItems: "center",
        backgroundColor: (traitItems == null ? void 0 : traitItems.backgroundColor) || "surface.card.secondary"
      }
    },
    image && /* @__PURE__ */ React10.createElement(Flex, { marginInlineEnd: "threeQuarters", justifyContent: "center" }, /* @__PURE__ */ React10.createElement(StyledImage, { src: image, alt: imageAltText })),
    /* @__PURE__ */ React10.createElement(StackLayout7, { space: "$quarter" }, /* @__PURE__ */ React10.createElement(SubtitleOne2, { as: HeadingThree2, fontWeight: "bold" }, /* @__PURE__ */ React10.createElement(ConditionalLink2, { ref: linkRef, onClick: onCardClick, url: actionLink }, heading)), body && /* @__PURE__ */ React10.createElement(ParagraphText3, { htmlStringOptions: BodyTextHtmlTagOptions }, body))
  );
};

// src/components/carousel-content-card-widget/carousel-content-card-widget.component.tsx
import React11, { useRef as useRef3 } from "react";
import {
  Image as Image3,
  SubtitleOne as SubtitleOne3,
  Caption,
  SubtitleTwo,
  Box as Box4,
  HeadingThree as HeadingThree3,
  Text as Text2
} from "@leagueplatform/genesis-commons";
import {
  StackLayout as StackLayout8,
  ConditionalLinkCard as ConditionalLinkCard4,
  ConditionalLink as ConditionalLink3
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText4 } from "@leagueplatform/genesis-core";

// src/constants.ts
var COMPLEX_WIDGET_CARDS_WIDTH = "275px";
var CAROUSEL_CONTENT_CARD_WIDTH = "282px";

// src/components/carousel-content-card-widget/carousel-content-card-widget.component.tsx
var CarouselContentCardWidget = ({
  title,
  overline,
  description,
  imageAltText,
  badge,
  badgeImage,
  image,
  linkUrl,
  onClick
}) => {
  const linkRef = useRef3(null);
  const overlineId = `cc-${title.replace(/\s+/g, "-")}`;
  return /* @__PURE__ */ React11.createElement(
    ConditionalLinkCard4,
    {
      linkRef,
      hasLink: Boolean(linkUrl),
      cardStyle: {
        width: CAROUSEL_CONTENT_CARD_WIDTH,
        flexDirection: "column",
        height: "100%"
      }
    },
    /* @__PURE__ */ React11.createElement(
      Image3,
      {
        src: image,
        alt: imageAltText,
        css: { width: "100%", height: "176px", objectFit: "cover" },
        borderStartStartRadius: "medium",
        borderStartEndRadius: "medium",
        backgroundColor: "surface.background.secondary"
      }
    ),
    /* @__PURE__ */ React11.createElement(Box4, { margin: "oneAndHalf" }, /* @__PURE__ */ React11.createElement(StackLayout8, { space: "$half", css: { textAlign: "start" } }, /* @__PURE__ */ React11.createElement(
      SubtitleOne3,
      {
        as: HeadingThree3,
        "aria-describedby": overlineId,
        fontWeight: "bold"
      },
      /* @__PURE__ */ React11.createElement(ConditionalLink3, { ref: linkRef, url: linkUrl, onClick }, title)
    ), overline && /* @__PURE__ */ React11.createElement(Caption, { id: overlineId }, overline), description && /* @__PURE__ */ React11.createElement(ParagraphText4, { htmlStringOptions: BodyTextHtmlTagOptions }, description)), badge && /* @__PURE__ */ React11.createElement(BadgePill, null, badgeImage && /* @__PURE__ */ React11.createElement(
      Image3,
      {
        src: badgeImage,
        alt: "",
        width: "2rem",
        height: "2rem",
        marginInlineEnd: "half"
      }
    ), /* @__PURE__ */ React11.createElement(
      SubtitleTwo,
      {
        as: Text2,
        color: "onSurface.text.primary",
        textAlign: "center"
      },
      badge
    )))
  );
};

// src/components/small-visual-card-widget/small-visual-card-widget.component.tsx
import React12, { useMemo, useRef as useRef4 } from "react";
import {
  Flex as Flex2,
  Overline as Overline2,
  SubtitleOne as SubtitleOne4,
  HeadingThree as HeadingThree4,
  Text as Text3,
  Box as Box5
} from "@leagueplatform/genesis-commons";
import {
  StackLayout as StackLayout9,
  ConditionalLinkCard as ConditionalLinkCard5,
  ConditionalLink as ConditionalLink4
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText5 } from "@leagueplatform/genesis-core";
var SquareImage = ({
  image,
  imageAltText,
  isChildItem
}) => /* @__PURE__ */ React12.createElement(
  SquareImageContainer,
  {
    src: image,
    alt: imageAltText,
    maxWidth: "9.8rem",
    maxWidthDesktop: isChildItem ? "9.8rem" : "11.2rem"
  }
);
var SmallVisualCardWidget = ({
  overline,
  title,
  description,
  image,
  badges,
  imageAltText,
  linkUrl,
  isChildItem = false,
  onCardClick = () => {
  },
  traits
}) => {
  const linkRef = useRef4(null);
  const overlineId = `svc-${title.replace(/\s+/g, "-")}`;
  const traitItems = useGetTraitsForMedia(traits);
  const iconAlign = (traitItems == null ? void 0 : traitItems.iconAlignment) || "right";
  const textAlign = useMemo(
    () => iconAlign === "trailing" || iconAlign === "right" ? "flex-start" : "flex-end",
    [iconAlign]
  );
  return /* @__PURE__ */ React12.createElement(
    ConditionalLinkCard5,
    {
      linkRef,
      hasLink: Boolean(linkUrl),
      cardStyle: {
        flexWrap: "wrap",
        justifyContent: "space-between",
        padding: "oneAndHalf",
        alignItems: "center",
        backgroundColor: "surface.card.secondary"
      }
    },
    (iconAlign === "left" || iconAlign === "leading") && /* @__PURE__ */ React12.createElement(
      Flex2,
      {
        alignItems: "center",
        justifyContent: "flex-start",
        marginInlineEnd: {
          _: "threeQuarters",
          desktop: "two"
        }
      },
      /* @__PURE__ */ React12.createElement(
        SquareImage,
        {
          image,
          imageAltText,
          isChildItem
        }
      )
    ),
    /* @__PURE__ */ React12.createElement(Flex2, { flexDirection: "column", alignItems: textAlign, flex: "2" }, /* @__PURE__ */ React12.createElement(StackLayout9, { space: "$half" }, overline && /* @__PURE__ */ React12.createElement(Overline2, { id: overlineId, as: Text3, color: "onSurface.text.subdued" }, overline), /* @__PURE__ */ React12.createElement(StackLayout9, { space: "$quarter" }, /* @__PURE__ */ React12.createElement(
      SubtitleOne4,
      {
        as: HeadingThree4,
        fontWeight: "bold",
        "aria-describedby": overlineId
      },
      /* @__PURE__ */ React12.createElement(
        ConditionalLink4,
        {
          ref: linkRef,
          url: linkUrl,
          onClick: onCardClick
        },
        title
      )
    ), /* @__PURE__ */ React12.createElement(ParagraphText5, { htmlStringOptions: BodyTextHtmlTagOptions }, description))), badges && /* @__PURE__ */ React12.createElement(Box5, { marginTop: "threeQuarters" }, /* @__PURE__ */ React12.createElement(
      BadgeList,
      {
        badges,
        backgroundColor: traitItems == null ? void 0 : traitItems.badgeBackgroundColor
      }
    ))),
    (iconAlign === "right" || iconAlign === "trailing") && /* @__PURE__ */ React12.createElement(
      Flex2,
      {
        alignItems: "center",
        justifyContent: "flex-end",
        marginInlineStart: {
          _: "threeQuarters",
          desktop: "two"
        }
      },
      /* @__PURE__ */ React12.createElement(
        SquareImage,
        {
          image,
          imageAltText,
          isChildItem
        }
      )
    )
  );
};

// src/components/notification-banner-widget/notification-banner-widget.component.tsx
import React14 from "react";
import {
  Card as Card2,
  useClickableCard,
  StackLayout as StackLayout11,
  StackItem as StackItem2,
  Button,
  useThemeStrings
} from "@leagueplatform/genesis-core";

// src/components/notification-banner-widget/notification-banner-content.tsx
import React13, { forwardRef } from "react";
import {
  Card,
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout10,
  StackItem,
  HeadingText as HeadingText2,
  Box as Box6
} from "@leagueplatform/genesis-core";
var HeadingElement = forwardRef(
  ({ children, url, onCardClick }, ref) => {
    if (url)
      return /* @__PURE__ */ React13.createElement(
        Box6,
        {
          as: "a",
          onClick: onCardClick,
          href: url,
          ref,
          css: {
            "&&": { color: "$onSurfaceTextPrimary", textDecoration: "none" }
          }
        },
        children
      );
    if (onCardClick)
      return /* @__PURE__ */ React13.createElement(
        Box6,
        {
          as: "button",
          ref,
          type: "button",
          onClick: onCardClick,
          css: {
            "&&": {
              color: "$onSurfaceTextPrimary",
              border: "none",
              typography: "$subtitleOne",
              background: "none",
              padding: 0
            }
          }
        },
        children
      );
    return /* @__PURE__ */ React13.createElement("span", null, children);
  }
);
var NotificationBannerContent = forwardRef(
  ({
    image,
    imageAltText,
    heading,
    body,
    url,
    onCardClick
  }, ref) => /* @__PURE__ */ React13.createElement(React13.Fragment, null, image && /* @__PURE__ */ React13.createElement(StackItem, { verticalAlignment: "center" }, /* @__PURE__ */ React13.createElement(
    Card.Image,
    {
      image,
      imageAlt: imageAltText,
      css: {
        width: "$twoAndHalf",
        height: "$twoAndHalf"
      }
    }
  )), /* @__PURE__ */ React13.createElement(StackLayout10, { spacing: "$quarter" }, /* @__PURE__ */ React13.createElement(HeadingText2, { size: "sm", level: "2" }, /* @__PURE__ */ React13.createElement(HeadingElement, { url, onCardClick, ref }, heading)), /* @__PURE__ */ React13.createElement(
    ParagraphText6,
    {
      emphasis: "subtle",
      htmlStringOptions: BodyTextHtmlTagOptions
    },
    body
  )))
);

// src/components/notification-banner-widget/use-dismiss-action-hook.ts
import { useCallback, useState } from "react";
import { usePostDismissWidget } from "@leagueplatform/masonry-api";
var useDismissibleAction = (dismissibleLink, onDismissAnalytics) => {
  const [dismissed, setDismissed] = useState(false);
  const onDismiss = useCallback(() => {
    setDismissed(true);
    if (onDismissAnalytics)
      onDismissAnalytics();
  }, [setDismissed, onDismissAnalytics]);
  usePostDismissWidget(dismissed, dismissibleLink);
  return { dismissed, onDismiss };
};

// src/components/notification-banner-widget/notification-banner-widget.component.tsx
var NotificationBannerWidget = ({
  body,
  dismissibleLink,
  heading,
  image,
  imageAltText,
  onCardClick,
  onDismiss: onDismissAnalytics,
  url
}) => {
  const strings = useThemeStrings();
  const isClickable = !!(url || onCardClick);
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  const { dismissed, onDismiss } = useDismissibleAction(
    dismissibleLink,
    onDismissAnalytics
  );
  if (dismissed)
    return null;
  return /* @__PURE__ */ React14.createElement(Card2.Elevated, null, /* @__PURE__ */ React14.createElement(StackLayout11, { orientation: "horizontal", verticalAlignment: "stretch" }, isClickable ? /* @__PURE__ */ React14.createElement(
    Card2.ClickArea,
    {
      css: {
        display: "flex",
        flexDirection: "row",
        gap: "$one",
        padding: "$threeQuarters",
        paddingInlineEnd: "$half"
      },
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown
    },
    /* @__PURE__ */ React14.createElement(
      NotificationBannerContent,
      {
        body,
        heading,
        image,
        imageAltText,
        onCardClick,
        ref: primaryActionRef,
        url
      }
    )
  ) : /* @__PURE__ */ React14.createElement(
    StackLayout11,
    {
      orientation: "horizontal",
      spacing: "$one",
      verticalAlignment: "center",
      css: {
        padding: "$threeQuarters",
        paddingInlineEnd: "$half"
      }
    },
    /* @__PURE__ */ React14.createElement(
      NotificationBannerContent,
      {
        body,
        heading,
        image,
        imageAltText
      }
    )
  ), dismissibleLink && /* @__PURE__ */ React14.createElement(
    StackItem2,
    {
      verticalAlignment: "top",
      css: { padding: "$threeQuarters", paddingInlineStart: "$half" }
    },
    /* @__PURE__ */ React14.createElement(
      Button,
      {
        hideLabel: true,
        icon: "tinyClose",
        onClick: onDismiss,
        priority: "tertiary",
        quiet: true,
        size: "small"
      },
      strings.dismiss
    )
  )));
};

// src/components/notification-card-widget/notification-card-widget.component.tsx
import React16 from "react";
import {
  Card as Card3,
  useClickableCard as useClickableCard2,
  StackLayout as StackLayout13,
  Icon as Icon2,
  Box as Box8
} from "@leagueplatform/genesis-core";

// src/components/notification-card-widget/notification-card-content.component.tsx
import React15, { forwardRef as forwardRef2 } from "react";
import {
  ParagraphText as ParagraphText7,
  StackLayout as StackLayout12,
  HeadingText as HeadingText3,
  Box as Box7,
  UtilityText as UtilityText3
} from "@leagueplatform/genesis-core";
var eyebrowStyles = {
  borderRadius: "$medium",
  backgroundColor: "$surfaceBackgroundTertiary",
  padding: "$quarter $half",
  marginBottom: "$half"
};
var HeadingLink = forwardRef2(({ children, url, onCardClick }, ref) => {
  if (url)
    return /* @__PURE__ */ React15.createElement(
      Box7,
      {
        as: "a",
        onClick: onCardClick,
        href: url,
        ref,
        css: {
          "&&": { color: "$onSurfaceTextPrimary", textDecoration: "none" }
        }
      },
      children
    );
  if (onCardClick)
    return /* @__PURE__ */ React15.createElement(
      Box7,
      {
        as: "button",
        ref,
        type: "button",
        onClick: onCardClick,
        css: {
          "&&": {
            color: "$onSurfaceTextPrimary",
            border: "none",
            typography: "$subtitleOne",
            background: "none",
            padding: 0,
            cursor: "pointer"
          }
        }
      },
      children
    );
  return /* @__PURE__ */ React15.createElement("span", null, children);
});
var NotificationCardContent = forwardRef2(({ heading, subheading, info, eyebrow, url, onCardClick }, ref) => /* @__PURE__ */ React15.createElement(StackLayout12, null, eyebrow && /* @__PURE__ */ React15.createElement(UtilityText3, { css: eyebrowStyles, size: "eyebrow", emphasis: "emphasized" }, eyebrow), heading && /* @__PURE__ */ React15.createElement(HeadingLink, { onCardClick, url, ref }, /* @__PURE__ */ React15.createElement(HeadingText3, { size: "sm", level: "2", css: { cursor: "inherit" } }, heading)), subheading && /* @__PURE__ */ React15.createElement(
  ParagraphText7,
  {
    css: { "&:not(:last-child)": { marginBlockEnd: 0 } },
    htmlStringOptions: BodyTextHtmlTagOptions
  },
  subheading
), info && /* @__PURE__ */ React15.createElement(
  ParagraphText7,
  {
    emphasis: "subtle",
    size: "sm",
    htmlStringOptions: BodyTextHtmlTagOptions
  },
  info
)));

// src/components/notification-card-widget/notification-card-widget.component.tsx
var clickableCardStyles = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  gap: "$one",
  padding: "$one",
  paddingInlineEnd: "$quarter"
};
var NotificationCardWidget = ({
  eyebrow,
  heading,
  info,
  onCardClick,
  subheading,
  url
}) => {
  const isClickable = Boolean(url || onCardClick);
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard2();
  return /* @__PURE__ */ React16.createElement(Card3.Elevated, { backgroundColor: "secondary" }, /* @__PURE__ */ React16.createElement(StackLayout13, { orientation: "horizontal", verticalAlignment: "stretch" }, isClickable ? /* @__PURE__ */ React16.createElement(
    Card3.ClickArea,
    {
      css: clickableCardStyles,
      onCardMouseDown,
      onCardMouseUp,
      ref: clickAreaRef
    },
    /* @__PURE__ */ React16.createElement(
      NotificationCardContent,
      {
        eyebrow,
        heading,
        info,
        onCardClick,
        ref: primaryActionRef,
        subheading,
        url
      }
    ),
    isClickable && /* @__PURE__ */ React16.createElement(Icon2, { icon: "interfaceChevronForward" })
  ) : /* @__PURE__ */ React16.createElement(Box8, { css: { padding: "$one" } }, /* @__PURE__ */ React16.createElement(
    NotificationCardContent,
    {
      eyebrow,
      heading,
      info,
      onCardClick,
      ref: primaryActionRef,
      subheading,
      url
    }
  ))));
};

// src/components/welcome-banner/welcome-banner.component.tsx
import React17 from "react";
import {
  Flex as Flex3,
  HeadingOne,
  BodyOneSecondary
} from "@leagueplatform/genesis-commons";
import { PageHeaderBackground } from "@leagueplatform/web-common-components";
var WelcomeBanner = ({ heading, subheading }) => /* @__PURE__ */ React17.createElement(PageHeaderBackground, null, /* @__PURE__ */ React17.createElement(Flex3, { align: "center", width: "100%", mt: 0 }, /* @__PURE__ */ React17.createElement(Flex3, { flexDirection: "column" }, /* @__PURE__ */ React17.createElement(HeadingOne, { textAlign: "start", marginTop: "oneAndHalf" }, heading), subheading && /* @__PURE__ */ React17.createElement(BodyOneSecondary, { marginTop: "threeQuarters" }, subheading))));

// src/components/image-footer/image-footer.component.tsx
import React18 from "react";
import { ImageMessage } from "@leagueplatform/genesis-core";
var ImageAlignMap = /* @__PURE__ */ ((ImageAlignMap2) => {
  ImageAlignMap2["start"] = "start";
  ImageAlignMap2["end"] = "end";
  ImageAlignMap2["left"] = "start";
  ImageAlignMap2["center"] = "center";
  ImageAlignMap2["right"] = "end";
  return ImageAlignMap2;
})(ImageAlignMap || {});
var ImageFooter = ({
  imageAltText,
  imageUrl,
  traits
}) => {
  const traitItems = useGetTraitsForMedia(traits);
  return /* @__PURE__ */ React18.createElement(
    ImageMessage,
    {
      image: imageUrl,
      imageAlt: imageAltText,
      imageHeight: +((traitItems == null ? void 0 : traitItems.imageHeight) || "50"),
      imageHorizontalAlignment: (traitItems == null ? void 0 : traitItems.imageAlign) ? ImageAlignMap[traitItems.imageAlign] : "center"
    }
  );
};

// src/components/hero-banner/hero-banner.component.tsx
import React20, { useRef as useRef5, useState as useState2, useEffect, useLayoutEffect } from "react";
import {
  Box as Box9,
  HeadingText as HeadingText4,
  ParagraphText as ParagraphText8,
  queryHelpers as queryHelpers5,
  StackItem as StackItem4,
  StackLayout as StackLayout14,
  styled as styled2,
  useMediaQuery as useMediaQuery5,
  UtilityText as UtilityText4,
  VisuallyHidden
} from "@leagueplatform/genesis-core";
import { useConfigProperty as useConfigProperty2 } from "@leagueplatform/config";
import { normalizeInternalUrl } from "@leagueplatform/web-common";

// src/components/common/page-header-background/page-header-background.tsx
import React19 from "react";
import { useConfigProperty } from "@leagueplatform/config";
import { StackItem as StackItem3, useTheme } from "@leagueplatform/genesis-core";
import { get } from "lodash";
var DEFAULT_STYLES = {
  height: "140px",
  width: "20024px",
  smallScreenWidth: "5000px",
  backgroundColor: "$decorativeBrandPrimaryPastel"
};
var PageHeaderBackground2 = (_a) => {
  var _b = _a, {
    height = DEFAULT_STYLES.height,
    pageHeaderBackgroundHeight = DEFAULT_STYLES.height,
    pageHeaderBackgroundColor,
    backgroundImage,
    curved,
    imageAltText,
    imageHeight,
    className
  } = _b, rest = __objRest(_b, [
    "height",
    "pageHeaderBackgroundHeight",
    "pageHeaderBackgroundColor",
    "backgroundImage",
    "curved",
    "imageAltText",
    "imageHeight",
    "className"
  ]);
  var _a2;
  const theme = useTheme();
  const pageHeaderConfig = useConfigProperty("core.ui.components.pageHeader");
  const pageHeaderBackgroundColorCoreToken = (pageHeaderConfig == null ? void 0 : pageHeaderConfig.backgroundColor) && get(theme, pageHeaderConfig == null ? void 0 : pageHeaderConfig.backgroundColor);
  const isCurved = curved !== void 0 ? curved : (pageHeaderConfig == null ? void 0 : pageHeaderConfig.shape) !== "line";
  return /* @__PURE__ */ React19.createElement(
    StackItem3,
    __spreadValues({
      className: `masonry-page-header-background ${className}`,
      css: {
        height,
        backgroundColor: "transparent",
        marginTop: "$oneAndHalf",
        marginBottom: "$twoAndHalf",
        "@laptop": {
          marginTop: "56px",
          marginBottom: "56px"
        },
        "@desktop": {
          marginTop: "56px",
          marginBottom: "56px"
        },
        "&:before": {
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : `unset`,
          backgroundSize: imageHeight ? `auto ${imageHeight}px` : "auto",
          backgroundRepeat: "no-repeat",
          backgroundColor: `${(_a2 = pageHeaderBackgroundColor != null ? pageHeaderBackgroundColor : pageHeaderBackgroundColorCoreToken) != null ? _a2 : DEFAULT_STYLES.backgroundColor}`,
          content: '""',
          zIndex: "0",
          position: "absolute",
          "&:dir(ltr)": {
            backgroundPosition: `bottom calc(0px - 5px) left calc(100% - ${DEFAULT_STYLES.width}/2 + 50vw)`
          },
          "&:dir(rtl)": {
            backgroundPosition: `bottom calc(0px - 5px) right calc(100% - ${DEFAULT_STYLES.width}/2 + 50vw)`
          },
          width: `${DEFAULT_STYLES.width}`,
          height: `${DEFAULT_STYLES.width}`,
          insetInlineStart: `calc(50% - (${DEFAULT_STYLES.width} / 2))`,
          top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.width})`,
          borderRadius: `${isCurved ? DEFAULT_STYLES.width : 0}`,
          "@mobile": {
            "&:dir(ltr)": {
              backgroundPosition: `bottom calc(0px - 5px) left calc(100% - ${DEFAULT_STYLES.smallScreenWidth}/2 + 50vw)`
            },
            "&:dir(rtl)": {
              backgroundPosition: `bottom calc(0px - 5px) right calc(100% - ${DEFAULT_STYLES.smallScreenWidth}/2 + 50vw)`
            },
            top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.smallScreenWidth})`,
            insetInlineStart: `calc(50% - (${DEFAULT_STYLES.smallScreenWidth} / 2))`,
            width: `${DEFAULT_STYLES.smallScreenWidth}`,
            height: `${DEFAULT_STYLES.smallScreenWidth}`,
            borderRadius: `${isCurved ? DEFAULT_STYLES.smallScreenWidth : 0}`
          },
          "@mobileLandscape": {
            "&:dir(ltr)": {
              backgroundPosition: `bottom calc(0px - 5px) left calc(100% - ${DEFAULT_STYLES.smallScreenWidth}/2 + 50vw)`
            },
            "&:dir(rtl)": {
              backgroundPosition: `bottom calc(0px - 5px) right calc(100% - ${DEFAULT_STYLES.smallScreenWidth}/2 + 50vw)`
            },
            top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.smallScreenWidth})`,
            insetInlineStart: `calc(50% - (${DEFAULT_STYLES.smallScreenWidth} / 2))`,
            width: `${DEFAULT_STYLES.smallScreenWidth}`,
            height: `${DEFAULT_STYLES.smallScreenWidth}`,
            borderRadius: `${isCurved ? DEFAULT_STYLES.smallScreenWidth : 0}`
          }
        }
      }
    }, rest)
  );
};

// src/components/hero-banner/hero-banner.component.tsx
import { InternalOrExternalLinkButton as InternalOrExternalLinkButton3 } from "@leagueplatform/web-common-components";
var DecorativeIcon = styled2("img", {
  width: "100%",
  height: "100%",
  objectFit: "cover"
});
var HeroBanner = ({
  body,
  buttonAction = "",
  buttonLabel,
  eyebrow,
  heading,
  icon,
  image,
  imageAltText = "",
  onCardClick: onButtonClick,
  traits
}) => {
  const contentRef = useRef5(null);
  const [contentHeight, setContentHeight] = useState2(150);
  const isLaptopDown = useMediaQuery5(queryHelpers5.down("laptop"));
  const pageHeaderBackgroundHeightPadding = isLaptopDown ? 60 : 112;
  const appLevelHeaderShape = useConfigProperty2(
    "core.ui.components.pageHeader.shape"
  );
  const traitItems = useGetTraitsForMedia(traits);
  const isCurved = typeof (traitItems == null ? void 0 : traitItems.curved) === "boolean" ? traitItems == null ? void 0 : traitItems.curved : appLevelHeaderShape === "swoop";
  useLayoutEffect(() => {
    const reportWindowSize = () => {
      var _a, _b;
      setContentHeight((_b = (_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight) != null ? _b : contentHeight);
    };
    if (contentHeight !== void 0)
      window.addEventListener("resize", reportWindowSize);
    return () => window.removeEventListener("resize", reportWindowSize);
  }, [contentHeight]);
  useEffect(() => {
    var _a;
    if ((_a = contentRef == null ? void 0 : contentRef.current) == null ? void 0 : _a.clientHeight)
      setContentHeight(contentRef.current.clientHeight);
  }, []);
  return /* @__PURE__ */ React20.createElement(Box9, { css: { position: "relative" } }, /* @__PURE__ */ React20.createElement(
    PageHeaderBackground2,
    {
      height: `${contentHeight + pageHeaderBackgroundHeightPadding / 2}px`,
      pageHeaderBackgroundHeight: `${contentHeight + pageHeaderBackgroundHeightPadding}px`,
      imageHeight: traitItems == null ? void 0 : traitItems.imageHeight,
      pageHeaderBackgroundColor: traitItems == null ? void 0 : traitItems.backgroundColor,
      backgroundImage: image,
      curved: isCurved,
      imageAltText
    },
    /* @__PURE__ */ React20.createElement(
      StackLayout14,
      {
        css: { position: "relative" },
        horizontalAlignment: "start",
        orientation: "horizontal",
        spacing: "$one",
        verticalAlignment: "top"
      },
      /* @__PURE__ */ React20.createElement(
        StackItem4,
        {
          horizontalAlignment: "start",
          css: {
            marginInlineEnd: (traitItems == null ? void 0 : traitItems.includeSafeArea) ? "160px" : "none"
          },
          verticalAlignment: "top",
          ref: contentRef
        },
        /* @__PURE__ */ React20.createElement(
          StackLayout14,
          {
            horizontalAlignment: "start",
            orientation: "horizontal",
            spacing: "$oneAndHalf",
            verticalAlignment: "top"
          },
          icon && /* @__PURE__ */ React20.createElement(
            StackItem4,
            {
              css: {
                flex: "1 1 100%",
                overflow: "hidden",
                aspectRatio: "1 / 1",
                maxWidth: "64px",
                "@mobile": {
                  order: 2
                },
                "@laptop": {
                  maxWidth: "80px"
                },
                "@desktop": {
                  maxWidth: "96px"
                }
              }
            },
            /* @__PURE__ */ React20.createElement(DecorativeIcon, { src: icon, alt: "", "data-testid": "hero-icon" })
          ),
          /* @__PURE__ */ React20.createElement(
            StackItem4,
            {
              horizontalAlignment: "start",
              verticalAlignment: "top",
              className: "masonry-hero-banner-heading-wrapper"
            },
            eyebrow && /* @__PURE__ */ React20.createElement(UtilityText4, { size: "eyebrow" }, eyebrow),
            /* @__PURE__ */ React20.createElement(
              HeadingText4,
              {
                className: "masonry-hero-banner-heading",
                level: "1",
                size: {
                  "@initial": "xl",
                  "@laptop": "xxl",
                  "@desktop": "xxl"
                },
                css: {
                  marginTop: "$quarter"
                }
              },
              heading
            ),
            body && /* @__PURE__ */ React20.createElement(
              ParagraphText8,
              {
                htmlStringOptions: BodyTextHtmlTagOptions,
                css: {
                  typography: "$bodyTwo",
                  marginTop: "$threeQuarters",
                  color: "$onSurfaceTextPrimary",
                  "@laptop": {
                    typography: "$bodyOne"
                  },
                  "@desktop": {
                    typography: "$bodyOne"
                  }
                }
              },
              body
            ),
            buttonLabel && /* @__PURE__ */ React20.createElement(
              InternalOrExternalLinkButton3,
              {
                href: normalizeInternalUrl(buttonAction),
                onClick: onButtonClick,
                priority: "primary",
                size: "medium",
                type: "button",
                css: {
                  marginTop: "$one"
                }
              },
              buttonLabel
            ),
            image && /* @__PURE__ */ React20.createElement(
              VisuallyHidden,
              {
                "data-testid": "hero-img",
                role: "img",
                "aria-label": imageAltText
              }
            )
          )
        )
      )
    )
  ));
};

// src/components/progress-ring-card-widget/progress-ring-card-widget.component.tsx
import React21, { useRef as useRef6 } from "react";
import { Box as Box10, useTheme as useTheme2 } from "@leagueplatform/genesis-commons";
import {
  ProgressRing,
  ConditionalLinkCard as ConditionalLinkCard6,
  ConditionalLink as ConditionalLink5
} from "@leagueplatform/web-common-components";
import {
  HeadingText as HeadingText5,
  ParagraphText as ParagraphText9,
  UtilityText as UtilityText5,
  StackLayout as StackLayout15
} from "@leagueplatform/genesis-core";
var PROGRESS_RING_DIMENSION = 82;
var ProgressRingCardWidget = ({
  action,
  currentText,
  eyebrow,
  footerText,
  heading,
  image,
  imageAltText,
  onCardClick = () => {
  },
  progress,
  suffixText = "",
  traits
}) => {
  const { space } = useTheme2();
  const linkRefState = useRef6(null);
  const traitItems = useGetTraitsForMedia(traits);
  return /* @__PURE__ */ React21.createElement(StackLayout15, { horizontalAlignment: "stretch" }, /* @__PURE__ */ React21.createElement(
    ConditionalLinkCard6,
    {
      linkRef: linkRefState,
      hasLink: Boolean(action),
      cardStyle: {
        alignItems: "center",
        backgroundColor: "surface.card.secondary",
        borderRadius: "large",
        boxShadow: "card",
        flexDirection: "column",
        marginTop: `calc(${PROGRESS_RING_DIMENSION}px/2)`,
        padding: "oneAndHalf"
      }
    },
    /* @__PURE__ */ React21.createElement(
      Box10,
      {
        width: PROGRESS_RING_DIMENSION,
        height: PROGRESS_RING_DIMENSION,
        position: "relative",
        transform: `translateY(calc(-50% - ${space.oneAndHalf}px))`,
        marginBottom: `calc(-${PROGRESS_RING_DIMENSION}px/2 - ${space.oneAndHalf}px + ${space.threeQuarters}px)`
      },
      /* @__PURE__ */ React21.createElement(
        ProgressRing,
        {
          current: progress,
          customRingBackgroundColor: "success.background.subdued",
          customRingFillColor: "success.border.default",
          image,
          imageAltText,
          screenReaderText: `${currentText} ${suffixText || ""}`,
          size: PROGRESS_RING_DIMENSION,
          total: 100
        }
      )
    ),
    /* @__PURE__ */ React21.createElement(
      StackLayout15,
      {
        css: { width: "100%", textAlign: "center" },
        horizontalAlignment: "center",
        spacing: "$threeQuarters"
      },
      eyebrow && /* @__PURE__ */ React21.createElement(
        UtilityText5,
        {
          css: {
            color: "$onSurfaceTextSubdued"
          },
          size: "eyebrow"
        },
        eyebrow
      ),
      heading && /* @__PURE__ */ React21.createElement(
        HeadingText5,
        {
          level: "display",
          css: { marginTop: "$quarter !important" },
          size: "sm"
        },
        heading
      ),
      /* @__PURE__ */ React21.createElement(ParagraphText9, { as: "h3", size: "sm" }, /* @__PURE__ */ React21.createElement(
        ConditionalLink5,
        {
          ref: linkRefState,
          url: action,
          onClick: onCardClick
        },
        /* @__PURE__ */ React21.createElement(
          ParagraphText9,
          {
            as: "span",
            size: "sm",
            css: {
              fontWeight: (traitItems == null ? void 0 : traitItems.emphasizeCurrentValue) ? "bold" : "400"
            }
          },
          currentText
        ),
        " ",
        suffixText
      )),
      footerText && /* @__PURE__ */ React21.createElement(ParagraphText9, { size: "xs", css: { color: "$onSurfaceTextSubdued" } }, footerText)
    )
  ));
};

// src/components/section-header/section-header.component.tsx
import * as React22 from "react";
import {
  HeadingText as HeadingText6
} from "@leagueplatform/genesis-core";

// src/utils/map-heading-size-to-genesis-tokens.util.ts
var headingSizeMap = {
  "xx-large": "xxl",
  "x-large": "xl",
  large: "lg",
  medium: "md",
  small: "sm",
  "x-small": "xs"
};
var mapHeadingSizeToGenesisTokens = (headingSize) => {
  if (!headingSize || !(headingSize in headingSizeMap)) {
    return void 0;
  }
  return headingSizeMap[headingSize];
};

// src/components/section-header/section-header.component.tsx
var SectionHeader = ({
  heading,
  headingLevel = "2",
  paddingTop = "$one",
  traits
}) => {
  var _a;
  const traitItems = useGetTraitsForMedia(traits);
  const headingSize = (_a = mapHeadingSizeToGenesisTokens(traitItems == null ? void 0 : traitItems.headingSize)) != null ? _a : "xl";
  return /* @__PURE__ */ React22.createElement(
    HeadingText6,
    {
      size: headingSize,
      level: headingLevel,
      css: {
        paddingTop
      }
    },
    heading
  );
};

// src/components/carousel-widget/carousel-widget.component.tsx
import React23 from "react";
import { Box as Box11 } from "@leagueplatform/genesis-commons";
import { Carousel } from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText10 } from "@leagueplatform/genesis-core";
var CarouselWidget = ({
  title,
  description,
  headerLinkHint,
  headerLinkUrl,
  items,
  onScrollLeft,
  onScrollRight,
  onSelectItem,
  onSelectHeader
}) => /* @__PURE__ */ React23.createElement(Box11, { paddingTop: "one", width: "100%" }, /* @__PURE__ */ React23.createElement(
  Carousel,
  {
    name: title || "Content Cards",
    heading: title ? /* @__PURE__ */ React23.createElement(SectionHeader, { heading: title, paddingTop: "$none" }) : void 0,
    description: /* @__PURE__ */ React23.createElement(ParagraphText10, { htmlStringOptions: BodyTextHtmlTagOptions }, description),
    spaceBetweenCards: "oneAndHalf",
    linkCta: headerLinkHint,
    linkUrl: headerLinkUrl,
    linkOnClick: onSelectHeader,
    BackNavButtonAnalyticsFn: onScrollLeft,
    ForwardNavButtonAnalyticsFn: onScrollRight
  },
  items.map((item, index) => /* @__PURE__ */ React23.createElement(
    CarouselContentCardWidget,
    {
      key: item.title,
      title: item.title,
      image: item.image,
      imageAltText: item.imageAltText,
      linkUrl: item.linkUrl,
      overline: item.overline,
      description: item.description,
      badge: item.badge,
      badgeImage: item.badgeImage,
      onClick: () => {
        onSelectItem(item, index);
      }
    }
  ))
));

// src/components/generic-carousel-widget/generic-carousel-widget.component.tsx
import React24 from "react";
import { Carousel as Carousel2 } from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText11, Box as Box12 } from "@leagueplatform/genesis-core";
var GenericCarouselWidget = ({
  body,
  children,
  headerButtonAction,
  headerButtonLabel,
  heading,
  onScrollLeft,
  onScrollRight,
  onSelectHeader
}) => /* @__PURE__ */ React24.createElement(
  Box12,
  {
    css: {
      paddingTop: "$one"
    }
  },
  /* @__PURE__ */ React24.createElement(
    Carousel2,
    {
      name: heading || "Content Cards",
      heading: heading ? /* @__PURE__ */ React24.createElement(SectionHeader, { heading, paddingTop: "$none" }) : void 0,
      description: /* @__PURE__ */ React24.createElement(ParagraphText11, { htmlStringOptions: BodyTextHtmlTagOptions }, body),
      BackNavButtonAnalyticsFn: onScrollLeft,
      linkCta: headerButtonLabel,
      linkOnClick: onSelectHeader,
      linkUrl: headerButtonAction,
      ForwardNavButtonAnalyticsFn: onScrollRight,
      spaceBetweenCards: "oneAndHalf"
    },
    children
  )
);

// src/components/progress-bar-card-widget/progress-bar-card-widget.component.tsx
import React26, { useRef as useRef7 } from "react";
import { ConditionalLinkCard as ConditionalLinkCard7 } from "@leagueplatform/web-common-components";

// src/components/progress-bar-card-widget/progress-bar-card-content.component.tsx
import React25 from "react";
import { Box as Box13, Overline as Overline3 } from "@leagueplatform/genesis-commons";
import { ConditionalLink as ConditionalLink6 } from "@leagueplatform/web-common-components";
import {
  HeadingText as HeadingText7,
  ParagraphText as ParagraphText12,
  StackLayout as StackLayout16,
  UtilityText as UtilityText6,
  ProgressBar
} from "@leagueplatform/genesis-core";
var ProgressBarCardContent = ({
  eyebrow,
  heading,
  headingLevel = "3",
  headingSize = "sm",
  currentText,
  progress,
  suffixText,
  footerText,
  action,
  linkRefState,
  emphasizeCurrentValue = false,
  onCardClick
}) => /* @__PURE__ */ React25.createElement(
  StackLayout16,
  {
    orientation: "vertical",
    spacing: "$quarter",
    css: { margin: "$oneAndHalf", alignItems: "normal", height: "auto" }
  },
  eyebrow && /* @__PURE__ */ React25.createElement(Overline3, { as: "p", color: "onSurface.text.subdued", marginBottom: "quarter" }, eyebrow),
  /* @__PURE__ */ React25.createElement(StackLayout16, { spacing: "$threeQuarters", orientation: "vertical" }, heading && /* @__PURE__ */ React25.createElement(HeadingText7, { level: headingLevel, size: headingSize }, heading), /* @__PURE__ */ React25.createElement(ParagraphText12, { size: "sm", css: { marginBlockEnd: "$none !important" } }, /* @__PURE__ */ React25.createElement(ConditionalLink6, { ref: linkRefState, url: action, onClick: onCardClick }, /* @__PURE__ */ React25.createElement(
    ParagraphText12,
    {
      as: "span",
      size: "sm",
      css: {
        fontWeight: emphasizeCurrentValue ? "bold" : "400"
      }
    },
    currentText
  ), " ", suffixText)), /* @__PURE__ */ React25.createElement(Box13, { paddingBottom: "half", width: "100%" }, /* @__PURE__ */ React25.createElement(
    ProgressBar,
    {
      fillProgressValue: progress,
      accessibilityLabel: `${currentText} ${suffixText}`
    }
  )), /* @__PURE__ */ React25.createElement(
    UtilityText6,
    {
      emphasis: "subtle",
      size: "xs",
      css: {
        alignSelf: "flex-end"
      }
    },
    footerText
  ))
);

// src/components/progress-bar-card-widget/progress-bar-card-widget.component.tsx
var ProgressBarCardWithoutImage = ({
  action,
  currentText,
  emphasizeCurrentValue,
  eyebrow,
  footerText,
  heading,
  headingLevel,
  headingSize,
  linkRefState,
  onCardClick,
  progress,
  suffixText
}) => /* @__PURE__ */ React26.createElement(
  ProgressBarCardContent,
  {
    action,
    currentText,
    emphasizeCurrentValue,
    eyebrow,
    footerText,
    heading,
    headingLevel,
    headingSize,
    linkRefState,
    onCardClick,
    progress,
    suffixText
  }
);
var ProgressBarCardWithImage = ({
  action,
  currentText,
  emphasizeCurrentValue,
  eyebrow,
  footerText,
  heading,
  headingLevel,
  headingSize,
  image,
  imageAltText = "",
  isChildItem = false,
  linkRefState,
  onCardClick,
  progress,
  suffixText
}) => /* @__PURE__ */ React26.createElement(
  LargeImageCard,
  {
    image,
    imageAltText,
    isChildItem
  },
  /* @__PURE__ */ React26.createElement(
    ProgressBarCardContent,
    {
      action,
      eyebrow,
      heading,
      headingLevel,
      headingSize,
      currentText,
      emphasizeCurrentValue,
      footerText,
      linkRefState,
      onCardClick,
      progress,
      suffixText
    }
  )
);
var ProgressBarCardWidget = (_a) => {
  var _b = _a, {
    traits
  } = _b, props = __objRest(_b, [
    "traits"
  ]);
  const { image, action } = props;
  const linkRefState = useRef7(null);
  const traitItems = useGetTraitsForMedia(traits);
  const headingSize = mapHeadingSizeToGenesisTokens(traitItems == null ? void 0 : traitItems.headingSize);
  return /* @__PURE__ */ React26.createElement(
    ConditionalLinkCard7,
    {
      linkRef: linkRefState,
      hasLink: Boolean(action),
      cardStyle: {
        backgroundColor: "surface.card.secondary"
      }
    },
    image ? /* @__PURE__ */ React26.createElement(
      ProgressBarCardWithImage,
      __spreadProps(__spreadValues(__spreadValues({
        image,
        linkRefState
      }, traitItems), props), {
        headingSize
      })
    ) : /* @__PURE__ */ React26.createElement(
      ProgressBarCardWithoutImage,
      __spreadProps(__spreadValues(__spreadValues({
        action,
        linkRefState
      }, traitItems), props), {
        headingSize
      })
    )
  );
};

// src/components/two-up-card-content/two-up-card-content.component.tsx
import React27, { useRef as useRef8 } from "react";
import {
  HeadingThree as HeadingThree5,
  Image as Image4,
  SubtitleOne as SubtitleOne5
} from "@leagueplatform/genesis-commons";
import {
  ConditionalLink as ConditionalLink7,
  ConditionalLinkCard as ConditionalLinkCard8,
  StackLayout as StackLayout17
} from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText13 } from "@leagueplatform/genesis-core";
var TwoUpCardContent = ({
  heading,
  body,
  imageAltText,
  image,
  actionLink,
  onClick = () => {
  }
}) => {
  const linkRef = useRef8(null);
  return /* @__PURE__ */ React27.createElement(
    ConditionalLinkCard8,
    {
      linkRef,
      hasLink: Boolean(actionLink),
      cardStyle: {
        padding: "oneAndHalf",
        width: "100%",
        backgroundColor: "surface.card.secondary"
      }
    },
    /* @__PURE__ */ React27.createElement(StackLayout17, { space: "$half" }, /* @__PURE__ */ React27.createElement(
      Image4,
      {
        borderRadius: "medium",
        src: image,
        alt: imageAltText,
        height: "4.2rem",
        width: "4.2rem"
      }
    ), /* @__PURE__ */ React27.createElement(StackLayout17, { space: "$quarter" }, /* @__PURE__ */ React27.createElement(SubtitleOne5, { as: HeadingThree5, fontWeight: "bold" }, /* @__PURE__ */ React27.createElement(ConditionalLink7, { onClick, ref: linkRef, url: actionLink }, heading)), body && /* @__PURE__ */ React27.createElement(ParagraphText13, { htmlStringOptions: BodyTextHtmlTagOptions }, body)))
  );
};

// src/components/two-up-card-widget/two-up-card-widget.component.tsx
import React28 from "react";
import { Flex as Flex4, css as css3, genesisStyled as genesisStyled4 } from "@leagueplatform/genesis-commons";
var StyledFlex = genesisStyled4(Flex4)(
  css3({
    justifyContent: "space-between",
    "&& > * + *": {
      marginInlineStart: "one"
    }
  })
);
var StyledLi = genesisStyled4("li")(
  css3({
    width: "100%",
    display: "flex",
    flexDirection: "row"
  })
);
var TwoUpCardWidget = ({
  items,
  onItemClick
}) => /* @__PURE__ */ React28.createElement(StyledFlex, { as: "ul" }, items.map((card, index) => {
  const { heading, body, image, imageAltText, actionLink } = card;
  return /* @__PURE__ */ React28.createElement(StyledLi, { key: heading }, /* @__PURE__ */ React28.createElement(
    TwoUpCardContent,
    {
      heading,
      body,
      image,
      imageAltText,
      actionLink,
      onClick: () => onItemClick(card, index)
    }
  ));
}));

// src/components/stack-widget-wrapper/stack-widget-wrapper.component.tsx
import * as React30 from "react";
import {
  StackLayout as StackLayout18,
  ParagraphText as ParagraphText14
} from "@leagueplatform/genesis-core";

// src/common/grid-container/grid-container.tsx
import { Box as Box14 } from "@leagueplatform/genesis-core";
import * as React29 from "react";
var DEFAULT_STYLES2 = {
  MIN_GRID_ITEM_WIDTH: "250px",
  GRID_COLUMN_COUNT: 2
};
function GridContainer({
  gridColumnCount = DEFAULT_STYLES2.GRID_COLUMN_COUNT,
  minGridItemWidth = DEFAULT_STYLES2.MIN_GRID_ITEM_WIDTH,
  children
}) {
  const gapCount = gridColumnCount - 1;
  const totalGapWidth = gapCount * 16;
  const maxGridItemWidth = `calc((100% - ${totalGapWidth}px) / ${gridColumnCount})`;
  return /* @__PURE__ */ React29.createElement(
    Box14,
    {
      css: {
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(max(${minGridItemWidth}, ${maxGridItemWidth}), 1fr));`,
        gridGap: "$one"
      }
    },
    children
  );
}

// src/components/stack-widget-wrapper/stack-widget-wrapper.component.tsx
function StackOrGrid({
  gridColumnCount,
  orientation,
  children
}) {
  if (orientation === "grid") {
    return /* @__PURE__ */ React30.createElement(GridContainer, { gridColumnCount }, children);
  }
  return /* @__PURE__ */ React30.createElement(
    StackLayout18,
    {
      spacing: "$one",
      horizontalAlignment: "stretch",
      verticalAlignment: "stretch",
      orientation
    },
    children
  );
}
var StackWidgetWrapper = ({
  children,
  gridColumnCount,
  heading,
  headingLevel,
  body,
  orientation,
  traits
}) => {
  if (!children)
    return null;
  return /* @__PURE__ */ React30.createElement(
    StackLayout18,
    {
      spacing: "$one",
      orientation: "vertical",
      horizontalAlignment: "stretch"
    },
    heading && /* @__PURE__ */ React30.createElement(
      SectionHeader,
      {
        heading,
        headingLevel,
        traits
      }
    ),
    body && /* @__PURE__ */ React30.createElement(ParagraphText14, null, body),
    /* @__PURE__ */ React30.createElement(StackOrGrid, { orientation, gridColumnCount }, children)
  );
};

// src/components/error-page/error-page.component.tsx
import React31 from "react";
import {
  Box as Box15
} from "@leagueplatform/genesis-commons";
import { ErrorState } from "@leagueplatform/web-common-components";
import { handleStaticAsset } from "@leagueplatform/asset-config";

// src/hooks/use-error-message.hook.ts
import { useIntl } from "@leagueplatform/locales";
var ERROR_TYPES = /* @__PURE__ */ ((ERROR_TYPES3) => {
  ERROR_TYPES3["API_ERROR"] = "api_error";
  ERROR_TYPES3["NO_CONNECTION"] = "no_connection";
  return ERROR_TYPES3;
})(ERROR_TYPES || {});
var defaultTryAgainHandler = () => window.location.reload();
var useErrorMessage = (errorType) => {
  const { $tmap } = useIntl();
  const heading = $tmap({
    ["api_error" /* API_ERROR */]: "ERROR_HEADING_GENERIC",
    ["no_connection" /* NO_CONNECTION */]: "ERROR_HEADING_NO_CONNECTION"
  });
  const body = $tmap({
    ["api_error" /* API_ERROR */]: "ERROR_CAPTION_BACKEND",
    ["no_connection" /* NO_CONNECTION */]: "ERROR_CAPTION_NO_CONNECTION"
  });
  const ErrorMessages = {
    ["api_error" /* API_ERROR */]: {
      headingString: heading("api_error" /* API_ERROR */),
      bodyString: body("api_error" /* API_ERROR */),
      buttonAction: defaultTryAgainHandler
    },
    ["no_connection" /* NO_CONNECTION */]: {
      headingString: heading("no_connection" /* NO_CONNECTION */),
      bodyString: body("no_connection" /* NO_CONNECTION */),
      hideButton: true
    }
  };
  return ErrorMessages[errorType];
};

// src/components/error-page/error-page.component.tsx
var FullScreenContainer = ({
  backgroundColor,
  children,
  labelledbyId,
  describedbyId: describedbyId2
}) => /* @__PURE__ */ React31.createElement(
  Box15,
  {
    role: "dialog",
    width: "100vw",
    height: "100vh",
    position: "fixed",
    inset: "0",
    insetInlineStart: "0",
    zIndex: "100",
    backgroundColor,
    "aria-labelledby": labelledbyId,
    "aria-describedby": describedbyId2
  },
  children
);
var LabelledbyId = "full-page-error-heading";
var describedbyId = "full-page-error-desc";
var ErrorPage = ({ errorType }) => {
  const { headingString, bodyString, buttonText, onButtonClick, hideButton } = useErrorMessage(errorType);
  const imageSrc = handleStaticAsset("ERROR_STATE_COVER");
  return /* @__PURE__ */ React31.createElement(
    FullScreenContainer,
    {
      labelledbyId: LabelledbyId,
      describedbyId,
      backgroundColor: "surface.background.primary"
    },
    /* @__PURE__ */ React31.createElement(
      Box15,
      {
        position: "fixed",
        top: "50%",
        insetInlineStart: "50%",
        transform: "translate(-50%, -50%)"
      },
      /* @__PURE__ */ React31.createElement(
        ErrorState,
        {
          imageSrc,
          headingString,
          bodyString,
          buttonText,
          hideButton,
          onButtonClick,
          labelledbyId: LabelledbyId,
          describedbyId,
          error: null
        }
      )
    )
  );
};

// src/components/skeletons/extra-small-skeleton.component.tsx
import { SkeletonRectangle } from "@leagueplatform/genesis-core";
import React32 from "react";
var ExtraSmallSkeleton = (_a) => {
  var props = __objRest(_a, []);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React32.createElement(SkeletonRectangle, __spreadValues({ height: 96 }, props))
  );
};

// src/components/skeletons/small-skeleton.component.tsx
import { Box as Box16, SkeletonRectangle as SkeletonRectangle2 } from "@leagueplatform/genesis-core";
import React33 from "react";
var SmallSkeleton = (_a) => {
  var props = __objRest(_a, []);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React33.createElement(Box16, __spreadValues({ "aria-busy": true, "aria-live": "polite" }, props), /* @__PURE__ */ React33.createElement(
      SkeletonRectangle2,
      {
        height: {
          "@initial": "160px",
          "@mobile": "180px"
        }
      }
    ))
  );
};

// src/components/skeletons/large-skeleton.component.tsx
import { SkeletonRectangle as SkeletonRectangle3 } from "@leagueplatform/genesis-core";
import React34 from "react";
var LargeSkeleton = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React34.createElement(
    SkeletonRectangle3,
    __spreadValues({
      height: {
        "@initial": "196px",
        "@tablet": "220px",
        "@mobileLandscape": "220px",
        "@mobile": "396px"
      }
    }, props)
  );
};

// src/components/skeletons/hero-banner-skeleton.component.tsx
import {
  Box as Box17,
  SkeletonRectangle as SkeletonRectangle4,
  StackLayout as StackLayout19
} from "@leagueplatform/genesis-core";
import React35 from "react";
var HeroBannerSkeleton = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ React35.createElement(
    Box17,
    __spreadValues({
      css: {
        height: "184px",
        "@tablet": {
          height: "232px"
        },
        "@mobileLandscape": {
          height: "232px"
        },
        "@laptop": {
          height: "351px"
        },
        "@desktop": {
          height: "351px"
        }
      }
    }, props),
    /* @__PURE__ */ React35.createElement(
      StackLayout19,
      {
        css: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: 0,
          height: "auto",
          paddingBlock: "$twoAndHalf",
          paddingInline: "$three",
          "@mobile": {
            paddingBlock: "$oneAndHalf",
            paddingInline: "$oneAndHalf"
          },
          backgroundColor: "$decorativeBrandPrimaryPastel"
        }
      },
      /* @__PURE__ */ React35.createElement(
        SkeletonRectangle4,
        {
          height: {
            "@initial": "136px",
            "@laptop": "255px",
            "@desktop": "255px"
          }
        }
      )
    )
  );
};

// src/components/metric-card-widget/metric-card-widget.component.tsx
import * as React36 from "react";
import {
  HeadingText as HeadingText8,
  Icon as Icon3,
  ParagraphText as ParagraphText15,
  StackLayout as StackLayout20,
  styled as styled3,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
import { HtmlToReact } from "@leagueplatform/web-common";
import {
  ConditionalLink as ConditionalLink8,
  ConditionalLinkCard as ConditionalLinkCard9
} from "@leagueplatform/web-common-components";
var StyledImage2 = styled3("img", {
  contentFit: "cover",
  contentPosition: "center",
  height: "$three",
  width: "$three"
});
function MetricCardWidget({
  action,
  body,
  heading,
  image,
  imageAltText,
  measurements,
  onCardClick,
  timestamp
}) {
  const linkRef = React36.useRef(null);
  const displayMeasurements = !!(measurements == null ? void 0 : measurements.length);
  const displayBody = !displayMeasurements && !!body;
  return /* @__PURE__ */ React36.createElement(
    ConditionalLinkCard9,
    {
      linkRef,
      hasLink: Boolean(action),
      cardStyle: {
        flexWrap: "wrap",
        justifyContent: "space-between",
        padding: "oneAndHalf",
        backgroundColor: "surface.card.secondary"
      }
    },
    /* @__PURE__ */ React36.createElement(
      StackLayout20,
      {
        orientation: "horizontal",
        spacing: "$threeQuarters",
        verticalAlignment: "center"
      },
      image && /* @__PURE__ */ React36.createElement(StyledImage2, { src: image, alt: imageAltText }),
      /* @__PURE__ */ React36.createElement(
        StackLayout20,
        {
          css: {
            width: "100%"
          },
          orientation: "horizontal",
          horizontalAlignment: "spaceBetween"
        },
        /* @__PURE__ */ React36.createElement(
          StackLayout20,
          {
            css: {
              width: "100%"
            },
            spacing: "$quarter",
            verticalAlignment: "spaceBetween"
          },
          /* @__PURE__ */ React36.createElement(HeadingText8, { size: "sm", level: "3", color: "$onSurfaceTextPrimary" }, /* @__PURE__ */ React36.createElement(ConditionalLink8, { ref: linkRef, url: action, onClick: onCardClick }, heading)),
          displayMeasurements ? /* @__PURE__ */ React36.createElement(StackLayout20, { orientation: "horizontal" }, /* @__PURE__ */ React36.createElement(
            ParagraphText15,
            {
              "data-testid": "measurement",
              css: {
                marginInlineEnd: "$threeQuarters",
                width: "100%",
                "&&": {
                  marginBlockEnd: "$none"
                }
              }
            },
            measurements.map(({ value, unit }) => /* @__PURE__ */ React36.createElement(React36.Fragment, { key: `${value}${unit}` }, /* @__PURE__ */ React36.createElement(
              UtilityText7,
              {
                css: {
                  paddingInlineEnd: "$quarter",
                  typography: "$headingThree"
                }
              },
              value
            ), unit && /* @__PURE__ */ React36.createElement(
              UtilityText7,
              {
                css: {
                  typography: "$label",
                  color: "$onSurfaceTextSubdued",
                  paddingInlineEnd: "$quarter"
                }
              },
              unit,
              " "
            )))
          )) : null,
          displayBody ? /* @__PURE__ */ React36.createElement(
            UtilityText7,
            {
              css: {
                typography: "$caption",
                color: "$onSurfaceTextSubdued"
              }
            },
            /* @__PURE__ */ React36.createElement(HtmlToReact, { htmlString: body })
          ) : null
        ),
        timestamp && /* @__PURE__ */ React36.createElement(
          ParagraphText15,
          {
            css: {
              typography: "$label",
              color: "$onSurfaceTextSubdued"
            }
          },
          timestamp
        )
      ),
      action ? /* @__PURE__ */ React36.createElement(
        Icon3,
        {
          size: 24,
          icon: "interfaceChevronForward",
          tint: "$onSurfaceIconPrimary"
        }
      ) : null
    )
  );
}

// src/components/layout-renderer/layout-renderer.component.tsx
import * as React37 from "react";
import { merge } from "lodash";
import { WidgetType as WidgetType2, Orientation as Orientation2 } from "@leagueplatform/masonry-api";
import { StackItem as StackItem5 } from "@leagueplatform/genesis-core";
var LayoutWSRenderer = ({
  heading,
  body,
  items,
  traits
}) => {
  const traitItems = useGetTraitsForMedia(traits);
  const orientation = useOrientationFromMediaQuery({
    traits,
    defaultOrientation: DefaultOrientationMap[WidgetType2.STACK]
  });
  if (!items)
    return null;
  return /* @__PURE__ */ React37.createElement(
    StackWidgetWrapper,
    {
      orientation,
      heading,
      body,
      gridColumnCount: traitItems == null ? void 0 : traitItems.gridColumnCount
    },
    React37.Children.map(items, (item) => /* @__PURE__ */ React37.createElement(
      StackItem5,
      {
        verticalAlignment: "fillContainer",
        css: { minWidth: COMPLEX_WIDGET_CARDS_WIDTH }
      },
      React37.cloneElement(item, {
        node: merge(
          {},
          item.props.node,
          {
            properties: {
              isChildItem: orientation === Orientation2.HORIZONTAL
            }
          }
        )
      })
    ))
  );
};

// src/components/carousel-WS-renderer/carousel-WS-renderer.component.tsx
import * as React38 from "react";
import { merge as merge2 } from "lodash";
import { Carousel as Carousel3 } from "@leagueplatform/web-common-components";
import { ParagraphText as ParagraphText16, StackItem as StackItem6 } from "@leagueplatform/genesis-core";
var CarouselWSRenderer = (_a) => {
  var _b = _a, {
    body,
    headerButtonAction,
    headerButtonLabel,
    heading,
    items,
    onScrollLeft,
    onScrollRight,
    onSelectHeader
  } = _b, props = __objRest(_b, [
    "body",
    "headerButtonAction",
    "headerButtonLabel",
    "heading",
    "items",
    "onScrollLeft",
    "onScrollRight",
    "onSelectHeader"
  ]);
  var _a2;
  if (!items)
    return null;
  return /* @__PURE__ */ React38.createElement(
    Carousel3,
    __spreadValues({
      name: heading || "masonry-carousel",
      heading: heading ? /* @__PURE__ */ React38.createElement(SectionHeader, { heading, paddingTop: "$none" }) : void 0,
      description: /* @__PURE__ */ React38.createElement(ParagraphText16, { htmlStringOptions: BodyTextHtmlTagOptions }, body),
      BackNavButtonAnalyticsFn: onScrollLeft,
      linkCta: headerButtonLabel,
      linkOnClick: onSelectHeader,
      linkUrl: headerButtonAction,
      ForwardNavButtonAnalyticsFn: onScrollRight,
      spaceBetweenCards: "oneAndHalf"
    }, props),
    (_a2 = React38.Children) == null ? void 0 : _a2.map(items, (child) => /* @__PURE__ */ React38.createElement(
      StackItem6,
      {
        css: { minWidth: COMPLEX_WIDGET_CARDS_WIDTH, height: "100%" }
      },
      React38.cloneElement(child, {
        node: merge2({}, child.props.node, {
          properties: { isChildItem: true }
        })
      })
    ))
  );
};

// src/index.ts
initModule();
export {
  CAROUSEL_CONTENT_CARD_WIDTH,
  COMPLEX_WIDGET_CARDS_WIDTH,
  CarouselContentCardWidget,
  CarouselWSRenderer,
  CarouselWidget,
  DefaultOrientationMap,
  ERROR_TYPES,
  ErrorPage,
  ExtraSmallSkeleton,
  ExtraSmallSkeleton as ExtraSmallSkeletonWSRenderer,
  GenericCarouselWidget,
  HeroBanner,
  HeroBannerSkeleton,
  HeroBanner as HeroBannerWSRenderer,
  HeroBannerSkeleton as HeroBannerWSSkeletonRenderer,
  ImageFooter,
  ImageFooter as ImageFooterWSRenderer,
  LargeImageCard,
  LargeSkeleton,
  LargeSkeleton as LargeSkeletonWSRenderer,
  LargeVisualCardWidget as LargeVisualCardWSRenderer,
  LargeVisualCardWidget,
  LayoutWSRenderer,
  MetricCardWidget as MetricCardWSRenderer,
  MetricCardWidget,
  NotificationBannerWidget as NotificationBannerWSRenderer,
  NotificationBannerWidget,
  NotificationCardWidget as NotificationCardWSRenderer,
  NotificationCardWidget,
  PageHeaderBackground2 as PageHeaderBackground,
  ProgressBarCardWidget as ProgressBarCardWSRenderer,
  ProgressBarCardWidget,
  ProgressRingCardWidget as ProgressRingCardWSRenderer,
  ProgressRingCardWidget,
  SectionHeader,
  SectionHeader as SectionHeaderWSRenderer,
  SmallSkeleton,
  SmallSkeleton as SmallSkeletonWSRenderer,
  SmallVisualCardWidget as SmallVisualCardWSRenderer,
  SmallVisualCardWidget,
  StackWidgetWrapper,
  TextAndCTACardWidget as TextAndCTACardWSRenderer,
  TextAndCTACardWidget,
  TwoUpCardContent,
  TwoUpCardWidget as TwoUpCardWSRenderer,
  TwoUpCardWidget,
  WelcomeBanner,
  XSVisualCardWidget as XSVisualCardWSRenderer,
  XSVisualCardWidget,
  useGetTraitsForMedia,
  useOrientationFromMediaQuery
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-widgets'] = window.leagueSDKsPresent['@leagueplatform/masonry-widgets'] || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-widgets'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/masonry-widgets'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/masonry-widgets module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map